import * as React from 'react'
import { TimelineLayoutMode } from './TimelineTraceDataTransformer'

interface Props {
    layoutMode: TimelineLayoutMode
    onChange: (layoutMode: TimelineLayoutMode) => void
}

const TIMELINE_LAYOUT_MODE_LABELS: Record<TimelineLayoutMode, string> = {
    classic: 'Classic',
    condensed: 'Condensed',
    waterfall: 'Waterfall',
}

export const TimelineLayoutModeDropdown = ({ layoutMode, onChange }: Props) => (
    <div className="dropdown" style={{ display: 'inline-block' }}>
        <button
            type="button"
            className="btn btn-xs btn-default dropdown-toggle tw-ml-8 tw-tooltip tw-tooltip-dataText tw-tooltip--top"
            data-tooltip-text="Timeline Layout Mode"
            data-toggle="dropdown"
        >
            <i className="fa fa-align-right" /> {TIMELINE_LAYOUT_MODE_LABELS[layoutMode]} <span className="caret" />
        </button>
        <ul className="dropdown-menu" role="menu">
            {Object.entries(TIMELINE_LAYOUT_MODE_LABELS).map(([option, label]) => (
                <li key={option} className={layoutMode === option ? 'active' : ''}>
                    <a
                        href="#"
                        onClick={ev => {
                            ev.preventDefault()
                            onChange(option as TimelineLayoutMode)
                        }}
                    >
                        {label}
                    </a>
                </li>
            ))}
        </ul>
    </div>
)
